import {useEffect} from 'react';
import {stripTitleBadge, titleWithBadge} from '../ticketsNotify';

/**
 * Mantém "(N) …" no título da aba. É a camada de alcance que NÃO pede permissão:
 * o título segue visível na barra de abas mesmo sem foco. Nada mais no app escreve
 * `document.title`, então não há disputa pelo valor.
 */
export const useDocumentTitleBadge = (count: number): void => {
  useEffect(() => {
    document.title = titleWithBadge(document.title, count);
    return () => {
      document.title = stripTitleBadge(document.title);
    };
  }, [count]);
};
